var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", [
    _c(
      "div",
      {
        staticClass: "panel wraper panel-gray",
        class: { "panel-canceled": _vm.tempCase.canceled }
      },
      [
        _c("div", { staticClass: "panel-header" }, [
          _c("div", { staticClass: "panel-title" }, [_vm._m(0)], 1)
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "panel-body", attrs: { id: "formbody" } },
          [
            _vm.request ? _vm._m(1) : _vm._e(),
            _vm._v(" "),
            _c(
              "q-field",
              {
                attrs: {
                  error: _vm.$v.tempCase.problem.$error,
                  "error-label": _vm._f("errorLabel")(_vm.$v.tempCase.problem)
                }
              },
              [
                _c("q-input", {
                  attrs: {
                    type: "textarea",
                    rows: 1,
                    autofocus: true,
                    "float-label": "Проблема"
                  },
                  model: {
                    value: _vm.tempCase.problem,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.tempCase,
                        "problem",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "tempCase.problem"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-field",
              {
                attrs: {
                  error: _vm.$v.tempCase.master.$error,
                  "error-label": _vm._f("errorLabel")(_vm.$v.tempCase.master)
                }
              },
              [
                _c("q-select", {
                  attrs: {
                    "float-label": "Исполнитель",
                    options: _vm.$store.getters.engineers,
                    disable: !_vm.isDispatcher
                  },
                  model: {
                    value: _vm.tempCase.master,
                    callback: function($$v) {
                      _vm.$set(_vm.tempCase, "master", $$v)
                    },
                    expression: "tempCase.master"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-field",
              {
                attrs: {
                  error: _vm.$v.tempCase.result.$error,
                  "error-label": _vm._f("errorLabel")(_vm.$v.tempCase.result)
                }
              },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": "Результат",
                    type: "textarea",
                    rows: 1
                  },
                  model: {
                    value: _vm.tempCase.result,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.tempCase,
                        "result",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "tempCase.result"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("q-checkbox", {
              staticClass: "q-mt-md q-mb-md",
              attrs: { label: "Отменен" },
              model: {
                value: _vm.tempCase.canceled,
                callback: function($$v) {
                  _vm.$set(_vm.tempCase, "canceled", $$v)
                },
                expression: "tempCase.canceled"
              }
            }),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "text-bolder" },
              [
                _vm._v("Работы (" + _vm._s(_vm.tempWorks.length) + ")\n      "),
                _c("q-btn", {
                  attrs: {
                    disabled: _vm.addDisabled,
                    title: "Добавить работу",
                    round: "",
                    small: "",
                    color: "secondary",
                    icon: "add"
                  },
                  on: { click: _vm.doAdd }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "panel-list" },
              [
                _c(
                  "transition-group",
                  { attrs: { tag: "div", name: "mylist" } },
                  _vm._l(_vm.tempWorks, function(work, index) {
                    return _c(
                      "div",
                      {
                        key: work.key,
                        staticClass: "panel",
                        class: _vm.$utils.statusClass(
                          work.completed ? 3 : 1,
                          work.msDate
                        )
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "panel-body" },
                          [
                            _c("q-btn", {
                              staticClass: "pull-right",
                              attrs: {
                                round: "",
                                outline: "",
                                small: "",
                                color: "negative",
                                icon: "delete_forever",
                                title: "Удалить работу"
                              },
                              on: {
                                click: function($event) {
                                  _vm.removeWork(index)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("q-field", [
                              _c(
                                "div",
                                { staticClass: "row group" },
                                [
                                  _c("q-checkbox", {
                                    class: !work.date
                                      ? ""
                                      : work.completed
                                        ? "text-positive"
                                        : "text-primary",
                                    attrs: {
                                      disable: !work.date,
                                      "keep-color": !!work.date,
                                      color: work.completed
                                        ? "positive"
                                        : "primary",
                                      "unchecked-icon": !!work.date
                                        ? "build"
                                        : "hourglass_empty",
                                      "checked-icon": "done",
                                      label: !work.date
                                        ? "Отложена"
                                        : work.completed
                                          ? "Выполнена"
                                          : "Запланирована"
                                    },
                                    model: {
                                      value: work.completed,
                                      callback: function($$v) {
                                        _vm.$set(work, "completed", $$v)
                                      },
                                      expression: "work.completed"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("q-datetime", {
                                    attrs: {
                                      placeholder: "Введите дату",
                                      clearable: "",
                                      popover: "",
                                      "first-day-of-week": 1,
                                      format: "DD.MM.YYYY"
                                    },
                                    model: {
                                      value: work.date,
                                      callback: function($$v) {
                                        _vm.$set(work, "date", $$v)
                                      },
                                      expression: "work.date"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "q-field",
                              {
                                attrs: {
                                  error:
                                    _vm.$v.tempWorks.$each[index].task.$error,
                                  "error-label": _vm._f("errorLabel")(
                                    _vm.$v.tempWorks.$each[index].task
                                  )
                                }
                              },
                              [
                                _c("q-input", {
                                  attrs: {
                                    "float-label": "Задача",
                                    type: "textarea",
                                    rows: 1
                                  },
                                  model: {
                                    value: work.task,
                                    callback: function($$v) {
                                      _vm.$set(
                                        work,
                                        "task",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "work.task"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "q-field",
                              {
                                attrs: {
                                  error:
                                    _vm.$v.tempWorks.$each[index].short.$error,
                                  "error-label": _vm._f("errorLabel")(
                                    _vm.$v.tempWorks.$each[index].short
                                  )
                                }
                              },
                              [
                                _c("q-input", {
                                  attrs: {
                                    "float-label": "Сделано",
                                    type: "textarea",
                                    rows: 1
                                  },
                                  model: {
                                    value: work.short,
                                    callback: function($$v) {
                                      _vm.$set(
                                        work,
                                        "short",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "work.short"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  })
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("save-btn", {
          attrs: {
            notChanged: _vm.notChanged,
            goView: _vm.goView,
            doSave: _vm.doSave
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("unit-path", {
      attrs: { id: _vm.iniCase.parent_id, lbl: _vm.lbl }
    })
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("request-card", { attrs: { request: _vm.request } })
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30f174d9", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30f174d9","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/case-edit.vue
// module id = null
// module chunks = 